import {Base} from "./base";

class PatService extends Base {
  constructor() {
    super();
  }

  /**
   * 健康档案-基本信息
   * @param patId
   * @returns {Promise<{}>}
   */
  async medicalinfoDetails(patId) {
    const {obj = {}} = await this.$http('nethos.pat.medicalinfo.details', {
      patId
    });
    return obj;
  }

  /**
   * 普通账号密码登录
   * @param options
   * @param options.patMobile
   * @param options.patPassword
   * @param options.deviceId
   * @returns {Promise<{token,obj}>}
   */
  async login(options) {
    const {token, obj, code} = await this.$http('nethos.pat.login', options)
    return {token, obj, code};
  }

  /**
   * 微信账号密码登录
   * @param options
   * @param options.patMobile
   * @param options.patPassword
   * @param options.openid
   * @param {'WECHAT'} options.deviceName
   * @returns {Promise<{code,token}>}
   */
  async passwordLogin(options) {
    return await this.$http('nethos.wechat.pat.password.login', options)
  }

  /**
   * 验证码登录
   * @param options
   * @param options.cid
   * @param options.captcha
   * @param options.patMobile
   * @param options.deviceId
   * @returns {Promise<T>}
   */
  async captchaLogin(options) {
    return await this.$http('nethos.pat.captcha.login', options);
  }

  /**
   * 微信登录
   * @description 授权登录页使用 prelogin
   * @param token
   * @returns {Promise<{code,obj}>}
   */
  async wechatLogin(tempToken) {
    let {code = '', obj = '', token, authorizedOpenId} = await this.$http('nethos.wechat.pat.login', {
      token: tempToken.trim(),
    }, {}, {showError: false})
    if (typeof obj === 'string') {
      try {
        obj = JSON.parse(obj);
      } catch (e) {
        obj = {}
      }
    }
    return {code, obj, token, authorizedOpenId};
  }

  /**
   * 确定设置为常用设备
   * @param options
   * @param options.patMobile
   * @param options.captcha
   * @param options.cid
   * @param options.deviceId
   * @param options.deviceName
   * @returns {Promise<{code,token}>}
   */
  async equipmentCaptchaLogin(options) {
    options.deviceName = 'WECHAT'
    const {code = '', token = ""} = await this.$http('nethos.pat.equipment.captcha.login', options);
    return {code, token};
  }

  /**
   *
   * @param options
   * @param options.patPassword
   * @param options.captcha
   * @param options.cid
   * @returns {Promise<*>}
   */
  async modifyPwd(options) {
    const {code} = await this.$http('nethos.pat.password.modify.v3', options);
    return code;
  }

  /**
   * 根据身份证获取简单的脱敏信息
   * @param patIdcard
   * @returns {Promise<T>}
   */
  async getSimpleInfoByIdCard(patIdcard) {
    return await this.$http('nethos.pat.info.idcard', {patIdcard})
  }

  /**
   * 根据用户Id和身份证正反面判断是否本人
   * @param options
   * @param options.patId
   * @param options.idCardFront
   * @param options.idCardBack
   * @returns {Promise<T>}
   */
  async credentialsCheck(options) {
    return await this.$http('nethos.pat.credentials.check', options);
  }

  /**
   * 根据身份证正反面修改登录手机号
   * @param options.checkToken
   * @param options.newCid
   * @param options.newCaptcha
   * @param options.mdType
   * @returns {Promise<void>}
   */
  async modifyPhoneByCredentials(options) {
    return await this.$http('nethos.pat.mobile.modify.tourist', options);
  }

  /**
   * 根据身份证获取院内预留手机号
   * @param idCard
   * @param {'ADD'|'UPDATE'} opType
   * @returns {Promise<T>}
   */
  async getHisPhoneByIdCard(idCard, opType = 'UPDATE') {
    return await this.$http('nethos.book.hos.patient', {
      idCard, opType
    }, {}, {showError: false});
  }

  /**
   * 患者修改资料
   * @param options.supplementStatus 是否完善信息
   */
  async patModifyV2(options) {
    return await this.$http('nethos.pat.info.modify.v2', options);
  }
}

export const patService = new PatService();



// WEBPACK FOOTER //
// ./src/services/pat.js